<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="分类：">
            <el-select size="medium" filterable v-model="searchForm.KIND_ID" placeholder="请选择" clearable>
              <el-option v-for="item in kindLists" :key="item.ID.toString() + item.CATALOG_NAME"
                :label="item.CATALOG_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单品：">
            <el-select size="medium" filterable v-model="searchForm.PRODUCT" remote reserve-keyword :remote-method="searchProduct"
              placeholder="请输入关键词" clearable>
              <el-option v-for="(item, index) in productLists" :key="item.PRODUCT_CODE.toString() + index.toString()"
                :label="item.NAME" :value="item.PRODUCT_CODE"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="queryTable">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <div id="main" style="width: 100%;height:600px;"></div>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  methods: {
    drawChart() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('main'));
      // 指定图表的配置项和数据
      const option = {
        legend: {
          data: ['品类均价', '单品价格'],
        },
        xAxis: {
          type: 'category',
          data: this.dateList,
        },
        tooltip: {
          trigger: 'axis',
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '品类均价',
            data: this.kindPrice,
            type: 'line',
          },
          {
            name: '单品价格',
            data: this.productPrice,
            type: 'line',
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      // 防止越界，重绘canvas
      window.onresize = myChart.resize;
      myChart.setOption(option);
    },
    queryTable() {
      this.$store.dispatch('PRICECHANGECHART_ALL', { KIND_ID: this.searchForm.KIND_ID, DAY_INTERVAL: this.searchForm.DAY_INTERVAL });
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 21,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.KIND_ID) {
        params.CATALOG_ID = this.searchForm.KIND_ID;
      }
      if (this.searchForm.PRODUCT) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT;
      }
      if (!this.searchForm.KIND_ID && !this.searchForm.PRODUCT) {
        this.$message.show({ text: '请输入分类或单品进行筛选', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        if (result[0]) {
          this.kindPrice = result[0].CATALOG_PRICE.CATALOG_PRICE;
          this.dateList = result[0].DATE;
          this.productPrice = result[0].PRODUCT_PRICE.PRODUCT_PRICE;
          this.drawChart();
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryKinds() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 22,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.kindLists = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryProduct() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 23,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.allProductLists = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    searchProduct(query) {
      if (query !== '') {
        this.productLists = this.allProductLists.filter((item) => item.NAME.toLowerCase()
          .indexOf(query.toLowerCase()) > -1);
      } else {
        this.productLists = [];
      }
    },
  },
  data() {
    return {
      searchForm: {},
      kindLists: [],
      allProductLists: [],
      kindPrice: [],
      dateList: [],
      productPrice: [],
      productLists: [],
    };
  },
  mounted() {
    // this.drawChart();
  },
  created() {
    this.$set(this.searchForm, 'KIND_ID', this.$store.state.PRICECHANGECHART_ALL.KIND_ID);
    this.$set(this.searchForm, 'DAY_INTERVAL', this.$store.state.PRICECHANGECHART_ALL.DAY_INTERVAL);
    this.queryKinds();
    this.queryProduct();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/priceChangeChart.vue